import dayjs from 'dayjs';
import { FC, useMemo } from 'react';

import { useTranslations } from '../../../../hooks/use-translations';

import { SelectForm, SelectFormProps } from './SelectForm';

type PeriodSelectFormProps = Omit<SelectFormProps<string>, 'options' | 'value' | 'defaultValue'> & {
  days?: (number | null)[];
  value?: string;
  defaultValue?: string;
};

export const PeriodSelectForm: FC<PeriodSelectFormProps> = (props) => {
  const { days = [7, 30, 365, null], ...selectProps } = props;

  const t = useTranslations('dictionaries.period');

  const options = useMemo<SelectFormProps<any>['options']>(
    () =>
      days.map((count) => ({
        name: count === null ? t('allTime') : t('lastNDays', { days: count }),
        value: (count === null ? dayjs().subtract(20, 'years') : dayjs().subtract(count, 'days')).format('YYYY-MM-DD'),
      })),
    [days, t]
  );

  return <SelectForm {...selectProps} options={options} defaultValue={props.defaultValue ?? options[0].value} />;
};
